export default __webpack_public_path__ + "static/media/flag-uzbekistn.62cbf352.svg";